// Builds the camelCase filter-row array consumed by ChatList#onApplyFilter
// (which snake-cases it before filterQueryGenerator). The conversations
// FilterService `contains` operator adds the %...% wildcards server-side,
// so we pass the raw, trimmed search text.
export const buildCaseNumberFilter = searchText => [
  {
    attributeKey: 'case_number',
    attributeModel: 'conversation_attribute',
    customAttributeType: 'conversation_attribute',
    filterOperator: 'contains',
    queryOperator: 'and',
    values: searchText.trim(),
  },
];
